<div class="card">
  <div class="card-details">
    <div class="card-header">
      <h3>{{ data.name }}</h3>
      <!-- <span class="badge">{{ data.benefitType }}</span> -->
    </div>

    <p
      class="card-text"
      matTooltip="{{ data.observation }}"
      matTooltipPosition="above"
      [matTooltipDisabled]="data.observation.length < 120"
    >
      {{ data.observation }}
    </p>

    <div class="card-extra-details">
      <small>{{ data.patientCity }} · {{ data.patientState }}</small>
      <span>•</span>
      <span class="badge-details">{{ data.inssStatus }}</span>
      <span>•</span>
      <span class="badge-details">{{
        data.hasMedicalDocument ? 'Possui documento médico' : 'Não possui documento médico'
      }}</span>
    </div>
  </div>

  <div class="card-actions">
    <ng-container *ngIf="selectedTab === 1; else history">
      <button mat-button class="btn-primary" (click)="acquireCase.emit(data.id)">
        Quero atender
      </button>
      <div class="card-actions-text">
        <span>Esse clique usa 1 crédito.</span>
        <span>
          <span>{{ data.totalAcquired }} de 3</span>
          <span> interessados </span>
        </span>
      </div>
    </ng-container>

    <ng-template #history>
      <button mat-button class="btn-primary" (click)="getCaseDetails.emit(data.caseAcquisitionId)">
        Detalhes
      </button>
    </ng-template>
  </div>
</div>
